import React from 'react';
import styled from 'styled-components';

import { Button } from 'src/presentation/components/agent_desktop_components';
import { DomainError } from '@ad-scripts/application/lib/error';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import { StepDescription, StepWizardActionContainer, StepWizardField } from './StepWizardLayout';
import { useAddEmailDomain } from 'src/presentation/components/pages/email/hooks/useAddEmailDomain';
import SpinnerTwo from '@ad-scripts/presentation/components/common/spinner_two';
import theme from '@ad-scripts/presentation/themes/default';

const AddEmailDomainStep1 = ({
  errors,
  onCancel,
  setValue,
  nextStep,
}: {
  errors?: DomainError[];
  nextStep?;
  onCancel?: () => void;
  setValue: (value) => void;
}): JSX.Element | null => {
  const nextStepHandler = value => {
    setValue(value);
    nextStep();
  };

  const { onEmailDomainSave, renderEmailDomainForm, isLoading } = useAddEmailDomain({
    errors,
    onSaveSuccess: nextStepHandler,
  });

  return (
    <>
      <StepWizardField>
        <H3 data-aid="wizard-title">Enter a sending domain</H3>
        <StepDescription data-aid="wizard-description">
          Specify an email domain you want to use to manage emails in Gladly. Once you save a sending domain, it cannot
          be changed.
        </StepDescription>
        {renderEmailDomainForm()}
      </StepWizardField>

      <StepWizardActionContainer>
        <StyledButton onClick={onEmailDomainSave} data-aid="editor-save" disabled={isLoading} loading={isLoading}>
          {isLoading ? <SpinnerTwo color={theme.colors.gray400} size={16} stroke={1} /> : 'Save and continue'}
        </StyledButton>
        <Button data-aid="editor-cancel" type={Button.Types.TEXT} onClick={onCancel}>
          Cancel
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

const StyledButton = styled(Button)`
  min-width: 140px;
`;

export default AddEmailDomainStep1;
